// extracted by mini-css-extract-plugin
module.exports = {"md":"WelcomeScreen_md_39hFW","ios":"WelcomeScreen_ios_2nxtG","loginscreen":"WelcomeScreen_loginscreen_2nycb"};